import {Button, Stack, Typography} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React, {useCallback, useState} from 'react';
import {trackPDPComingSoonNotficationRequested} from 'utils/analytics';
import ComingSoonFormContent from './ComingSoonFormContent';

export default function ComingSoonForm({colorCount, productId}) {
  const [formRequested, setFormRequested] = useState(false);
  const handleFormRequest = useCallback(() => {
    setFormRequested(true);
    trackPDPComingSoonNotficationRequested(productId);
  }, [productId]);

  return (
    <Stack
      alignItems={formRequested ? undefined : 'flex-start'}
      gap="0.5rem"
      width="100%">
      {colorCount > 1 && (
        <Typography
          sx={{
            color: 'rgba(0, 0, 0, 0.57)',
            fontSize: '0.825rem',
            fontWeight: 500,
            lineHeight: '125%',
            marginBottom: '0.5rem'
          }}>
          Imagery may not be available for all colors.
        </Typography>
      )}
      <Typography
        fontWeight={600}
        fontSize="1rem"
        data-testid="coming-soon-form-coming-soon-label">
        Coming Soon!
      </Typography>
      {formRequested ? (
        <ComingSoonFormContent productId={productId} />
      ) : (
        <Button
          onClick={handleFormRequest}
          size="large"
          data-testid="coming-soon-form-notify-me-button">
          Notify Me When Available
        </Button>
      )}
    </Stack>
  );
}

ComingSoonForm.propTypes = {
  colorCount: PropTypes.number.isRequired,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired
};
